declare global {
  interface Window {
    scrollToAnchor: (anchor: string) => void,
  }
}

export function debounce(func: (...args: Parameters<typeof debounce>) => void, wait?: number, immediate?: boolean): () => void {
  let timeout: number | null;

  return (): void => {
    const context = this,
      args = arguments;

    const later = () => {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };

    const callNow = immediate && !timeout;

    window.clearTimeout(timeout);
    timeout = window.setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
}

export const ready = (callback: () => void) => {
  if (document.readyState != "loading") {
    callback()
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
}

export const common = () => {
  // Красивый скролл к комментам
  window.scrollToAnchor = (anchor: string) => {
    const anchorNode = document.querySelector(`#${anchor}`)

    if (!anchorNode) {
      return
    }

    const offset = anchorNode.getBoundingClientRect().top + window.scrollY;

    window.scroll({
      top: offset - 100,
      left: 0,
      behavior: 'smooth'
    });
    return false;
  }
}
